import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const cards = [
  {
    title: "Powerful self-service tools",
    description: "Join 1000,000+ traders who copy winning strategies or earn commissions.",
    bgColor: "#ffffff",
  },
  {
    title: "Advanced charting system",
    description: "Visualize your trades like a pro with our customizable charts.",
    bgColor: "#f3f4f6",
  },
  {
    title: "Seamless payments integration",
    description: "Accept and manage payments from anywhere.",
    bgColor: "#e5e7eb",
  },
];

const ScrollStackCards = () => {
  const containerRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      cardRefs.current.forEach((card, index) => {
        gsap.fromTo(
          card,
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: containerRef.current,
              start: `top+=${index * window.innerHeight * 0.4} top`,
              end: `+=200`,
              scrub: true,
            },
          }
        );
      });

      ScrollTrigger.create({
        trigger: containerRef.current,
        start: "top top",
        end: `+=${cards.length * window.innerHeight * 0.6}`,
        pin: true,
        scrub: true,
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <div
        ref={containerRef}
        style={{
          display: "flex",
          height: "100vh",
          width: "100%",
          background: "#f8fafc",
          position: "relative",
        }}
      >
        {/* Left fixed content */}
        <div
          style={{
            flex: 1,
            padding: "4rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <h1 style={{ fontSize: "2.5rem", fontWeight: "bold" }}>
            Build Smarter
          </h1>
          <p style={{ marginTop: "1rem", color: "#555" }}>
            Tools that grow with your business and automate your workflow.
          </p>
        </div>

        {/* Right side cards stacking */}
        <div style={{ flex: 1, position: "relative", margin: "4rem" }}>
          {cards.map((card, i) => (
            <div
              key={i}
              ref={(el) => (cardRefs.current[i] = el)}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "70vh",
                borderRadius: "24px",
                background: card.bgColor,
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                padding: "2rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                opacity: 0,
              }}
            >
              <h2 style={{ fontSize: "1.8rem", marginBottom: "1rem" }}>
                {card.title}
              </h2>
              <p style={{ fontSize: "1rem", color: "#555" }}>{card.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Next Section */}
     
    </>
  );
};

export default ScrollStackCards;
